var Grid = (function () {


  var Utility = window.Utility || {};
  var ResponsiveBackground = window.ResponsiveBackground || {};
  var $grids = $('.hmc-grid-100');
  var $items = $('.hmc-grid-item');
  var $bgVideo = $('.hmc-grid-video');
  var $sliderImage = $('.acr-slider-image');
  var debounce;
  var $window = $(window);
  var scrollFactor = 0.5;
  var hasClipPath;
  var prefix;
  var viewports = {
    xs: {
      min: 320,
      max: 550,
    },
    sm: {
      min: 550,
      max: 1024,
    },
    lg: {
      min: 1024,
      max: 1400,
    },
    xl: {
      min: 1400,
      max: Infinity,
    },
  };

  function getBreakpoint(wW) {
    var breakpoint;

    if (wW < viewports.xs.max) {
      breakpoint = 'xs';
    } else if (wW < viewports.sm.max) {
      breakpoint = 'sm';
    } else if (wW < viewports.lg.max) {
      breakpoint = 'lg';
    } else {
      breakpoint = 'xl';
    }

    return breakpoint;
  }

  function layout() {
    $grids.each(function (i, grid) {
      var $grid = $(grid);

      var classes = $grid.attr('class').split(/\s+/);

      var wWidth = window.innerWidth;

      var breakpoint = getBreakpoint(wWidth);

      // Any grid data attributes
      if ($grid.data('height-' + breakpoint)) {
        if ($grid.data('height-' + breakpoint) !== $grid.height()) {
          $grid.css('height', $grid.data('height-' + breakpoint) + 'px');
        }
      } else {
        ResponsiveBackground.setHeight($grid.get(0));
      }

      // For Carousels
      if ($grid.filter('[class*="hmc-carousel-"]').length > 0) {
        var carouselBreakpoints = classes.filter(function (c) {
          if (c.indexOf('hmc-carousel-') === 0) {
            return true;
          }
        });

        $.each(carouselBreakpoints, function (i, carouselBreakpoint) {
          var viewport = carouselBreakpoint.split('hmc-carousel-')[1];

          var $carousel = $grid.find('.hmc-grid-carousel');

          var $originalTiles = $grid.find('.hmc-carousel-slide');

          if (wWidth > viewports[viewport].min
              && wWidth < viewports[viewport].max) {
            $originalTiles.css({
              display: 'none',
            });

            $carousel.find('.hmc-carousel-slide').css({
              display: 'block',
            });

            $carousel.addClass('visible');

            return false;
          }
          $originalTiles.css({
            display: '',
          });

          $carousel.removeClass('visible');

        });
      }
    });
  }

  function slideSmage($el) {
    var offsetStart = $el.data('start');
    var xOffset = $el.data('offset');
    var winTop = $window.scrollTop();
    var winBottom = winTop + $window.height();
    var elTop = $el.offset().top;
    var speed = ($el.data('speed') === undefined)
      ? scrollFactor : $el.data('speed');


    if (offsetStart === undefined) {
      offsetStart = 0;
    }

    if (xOffset === undefined) {
      xOffset = 0;
    }

    if ((elTop < winBottom)) {
      var height = ((winBottom - elTop) * speed);
      var y = height;
      var propertyName = prefix + 'clip-path';

      if ($el.data('opposite') === undefined) {
        var angle = $el.data('angle');
        var adjacent = $el.width();
        var tan;
        var opposite;

        angle = (angle === 90) ? 89 : angle;

        angle = (angle > 90) ? (180 - angle) : angle;

        tan = Utility.getTanDeg(angle);

        opposite = tan * adjacent;

        $el.data('opposite', opposite);
      }

      y += $el.data('opposite');

      if ($el.data('angle') > 90) {
        // console.log('if 3', elTop < winBottom, elTop, winBottom);
        $el.css(
          propertyName.toString(),
          'polygon(0% 0%, 100% 0%, 100% ' + y + 'px, 0% ' + height + 'px)',
        );
      } else if (winTop > offsetStart) {
        $el.css(
          propertyName.toString(),
          'polygon(0% 0%, 100% 0%, 100% ' + (height - xOffset)
            + 'px, 0% ' + (y - xOffset) + 'px)',
        );
      }
    }
  }

  function showVideo($el) {
    $el.css('display', 'block');
  }

  function backgroundVideoGrid($el) {
    var winTop = $window.scrollTop();
    var winBottom = winTop + $window.height();
    var elTop = $el.offset().top;
    var elBottom = elTop + $el.outerHeight();
    var play = $el.data('play');
    var stop = $el.data('stop');

    if ($el[0].currentSrc === '') {
      return true;
    }

    if (play === 'viewport' && stop === 'viewport') {
      if ((elTop < winBottom) && (elBottom > winTop)) {
        showVideo($el);

        $el[0].play();
      } else {
        $el[0].pause();
      }
    } else if (play === 'viewport' && stop === 'no') {
      if ((elTop < winBottom)) {
        showVideo($el);

        $el[0].play();
      }
    } else if (play === 'load' && stop === 'viewport') {
      if ((elBottom > winTop)) {
        showVideo($el);

        $el[0].play();
      } else {
        $el[0].pause();
      }
    } else if (play === 'load' && stop === 'no') {
      showVideo($el);

      $el[0].play();
    }
  }

  function onScroll() {
    var breakpoint = getBreakpoint(window.innerWidth);

    if (hasClipPath) {
      $sliderImage.each(function (index, element) {
        slideSmage($(element));
      });
    }

    if (breakpoint === 'lg' || breakpoint === 'xl') {
      $bgVideo.each(function (index, element) {
        backgroundVideoGrid($(element));
      });
    } else {
      $bgVideo.each(function (index, element) {
        element.pause();
      });
    }
  }

  function checkVideoBP() {
    var breakpoint = getBreakpoint(window.innerWidth);

    if (breakpoint === 'xs' || breakpoint === 'sm') {
      $bgVideo.css({
        display: 'none',
      });
    } else {
      onScroll();
    }
  }

  function sliderReadyImg(when) {
    if (!when) {
      when = 800;
    }

    setTimeout(function () {
      $sliderImage.each(function () {
        var $parent = $(this).parents('.slider-tile-content');

        $parent.height($(this).outerHeight());
      });
    }, when);
  }

  function resize() {
    layout();

    checkVideoBP();

    $sliderImage.each(function (index, element) {
      $(element).removeData('opposite');
    });

    sliderReadyImg(1);
  }

  function onResize() {
    clearTimeout(debounce);

    debounce = setTimeout(resize, 400);
  }

  function attachResize() {
    $(window).off('resize', layout);

    $(window).on('resize', onResize);

    $(window).on('ar.closemodal', layout);
  }

  function getBootstrapBreakpoint() {
    var breakpoint = getBreakpoint(window.innerWidth);

    if (breakpoint === 'lg') {
      breakpoint = 'md';
    } else if (breakpoint === 'xl') {
      breakpoint = 'lg';
    } else if (window.innerWidth >= viewports.xl.min) {
      breakpoint = 'xl';
    }

    return breakpoint;
  }

  function copyTiles() {
    $grids.each(function (i, grid) {
      var $grid = $(grid);

      // For Carousels
      if ($grid.filter('[class*="hmc-carousel-"]')) {
        var $originalTiles = $grid.find('.hmc-carousel-slide');

        if ($originalTiles.length > 1) {
          var $tiles = $originalTiles.clone();

          var $carousel = $grid.find('.hmc-grid-carousel');

          $carousel.html($tiles);

          $carousel.slick({
            dots: true,
            prevArrow: '<button type="button"'
              + ' class="acr-icon-arrow-large-left acr-f2 acr-mid-grey '
              + 'slick-prev slick-arrow"></button>',
            nextArrow: '<button type="button"'
              + ' class="acr-icon-arrow-large-right acr-f2 acr-mid-grey '
              + 'slick-next slick-arrow"></button>',
            useTransform: true,
          });
        }
      }
    });
  }

  function changeId(className) {
    var $visibleItems = $('.hmc-grid-item:not(.' + className + ')');
    $items.attr('id', '');

    $visibleItems.each(function (i, el) {
      if (!$(el).hasClass('slick-slide')) {
        $(el).attr('id', $(el).data('id'));
      }
    });
  }

  function attachScroll() {
    $(window).on('scroll', onScroll);
  }

  function onEnd() {
    $(this).css('display', 'none');
  }

  function attachVideoEnd() {
    $bgVideo.each(function (index, element) {
      element.addEventListener('ended', onEnd);
    });
  }

  function init() {
    if ($grids.length) {

      hasClipPath = $('html').hasClass('cssclippathpolygon');

      prefix = Utility.prefix().css;

      copyTiles();

      resize();

      attachResize();

      attachVideoEnd();

      onScroll();

      attachScroll();

      changeId('hidden-' + getBootstrapBreakpoint());

      sliderReadyImg();

      // Just in case we didn't get it
      setTimeout(function () {
        sliderReadyImg(1);
      }, 900);
    }
  }

  return {
    init: init,
    resize: resize,
  };
}());
